export interface GetLocationIdsRequest {
    planId: string;
    segment? : string [] 
  }